module.exports = __webpack_public_path__ + "img/gsb15.a51c576e.png";